import Hero from '@/components/home/Hero';
import Expertise from '@/components/home/Expertise';
import WhyBymat from '@/components/home/WhyBymat';
import BooksResources from '@/components/home/BooksResources';
import VideoTestimonials from '@/components/home/VideoTestimonials';
import Newsletter from '@/components/home/Newsletter';

const Home = () => {
  return (
    <>
      <Hero />
      <Expertise />
      <WhyBymat />
      <BooksResources />
      <VideoTestimonials />
      <Newsletter />
    </>
  );
};

export default Home;
